<h1
  class="title mb-2"
  [ngClass]="titleClass()"
  [class.has-text-centered]="isCentered()"
  [innerHtml]="header() | translate"
></h1>
@if (subHeader()) {
  <h2
    class="subtitle has-text-grey"
    [ngClass]="subtitleClass()"
    [class.has-text-centered]="isCentered()"
    [innerHtml]="subHeader() | translate"
  ></h2>
}
